import { useContext } from 'react';
import { useTranslation, Trans } from 'react-i18next';
import { ScreenerResultsCtx } from 'domains/signup/screener/Components/ScreenerResultsSummary/context';
import { AccordionList, AccordionListItem } from 'components/AccordionList';
import { Heading, Paragraph } from 'components/Typography';
import { Link } from '@expressable/syntax-ds';

const patientLinks = {
  child: {
    label: 'child',
    childPatientLink:
      'https://www.expressable.com/learning-center/tips-and-resources/what-is-a-speech-therapy-evaluation-and-how-to-prepare',
  },
  adult: {
    label: 'adult',
    adultPatientLink:
      'https://www.expressable.com/learning-center/adults/what-is-a-speech-therapy-evaluation-for-adults-and-how-should-you-prepare',
  },
};

export const ScreenerResultsFAQSection: React.FC = () => {
  const {
    results: { targetPatient },
  } = useContext(ScreenerResultsCtx);
  const { t } = useTranslation();

  return (
    <section>
      <AccordionList title="">
        <AccordionListItem
          summary={
            <Heading level="h7" className="font-semibold">
              {t(`screener.results.faq.whatHappens.title.${targetPatient}`)}
            </Heading>
          }
        >
          <Paragraph>{t(`screener.results.faq.whatHappens.text1.${targetPatient}`)}</Paragraph>
          <Paragraph>
            <Trans
              t={t}
              i18nKey={`screener.results.faq.whatHappens.text2.${targetPatient}`}
              components={[
                <Link to={patientLinks.child.childPatientLink} external children={patientLinks.child.label} />,
                <Link to={patientLinks.adult.adultPatientLink} external children={patientLinks.adult.label} />,
              ]}
            />
          </Paragraph>
        </AccordionListItem>

        <AccordionListItem
          summary={
            <Heading level="h7" className="font-semibold">
              {t(`screener.results.faq.whatsTheCost.title.${targetPatient}`)}
            </Heading>
          }
        >
          <Paragraph>{t(`screener.results.faq.whatsTheCost.text.${targetPatient}`)}</Paragraph>
        </AccordionListItem>

        <AccordionListItem
          summary={
            <Heading level="h7" className="font-semibold">
              {t(`screener.results.faq.whyExpressable.title.${targetPatient}`)}
            </Heading>
          }
        >
          <Paragraph>{t(`screener.results.faq.whyExpressable.text1.${targetPatient}`)}</Paragraph>
          <Paragraph>{t(`screener.results.faq.whyExpressable.text2.${targetPatient}`)}</Paragraph>
        </AccordionListItem>
      </AccordionList>
    </section>
  );
};
